import { FunctionComponent, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import NoPropertyAssociation from '../features/propertyAssociation/components/NoPropertyAssociation';
import SearchPropertyAssociation from '../features/propertyAssociation/components/SearchPropertyAssociation';
import { usePropertyAssociations } from '../features/propertyAssociation/propertyAssociationService';
import { clearAllLastAreaIds } from '../features/propertyAssociation/useLastAreaId';

const Home: FunctionComponent = () => {
    const { isAdmin, propertyAssociations } = usePropertyAssociations();
    const location = useLocation();

    // Clear all lastAreaId entries when navigating to home
    useEffect(() => {
        clearAllLastAreaIds();
    }, []);

    // Non-admin users with no property associations
    if (!isAdmin && propertyAssociations?.length === 0) {
        return <NoPropertyAssociation />;
    }

    // Auto-navigate if only one property association (for non-admins)
    if (!isAdmin && propertyAssociations?.length === 1) {
        return <Navigate to={`${propertyAssociations[0].propertyAssociationId}/areas`} replace state={location.state} />;
    }

    return (
        <div className="app__inner mt-4">
            <SearchPropertyAssociation />
        </div>
    );
};

export default Home;
